const marketExclusiveService = (() => {
  let queue = {};
  let cache = {};
  const CACHE_EXPIRATION_TIME = 5 * 60 * 1000; // Cache expires in 5 minutes

  const clear = () => {
    queue = {};
    cache = {};
  };

  let get;

  const getFromApi = async (productId) => {
    try {
      if (queue[productId]) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(get(productId));
          }, 500);
        });
      }

      queue[productId] = true;

      productId = encodeURI(productId);
      const response = await fetch(
        `/wp-json/shopify/v2/market-exclusives?id=${productId}`
      );

      return await response.json();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch market exclusives API:', error);

      return null;
    }
  };

  get = async (productId) => {
    productId = `${productId}`.replace('gid://shopify/Product/', '');

    const now = Date.now();
    if (
      cache[productId] &&
      now - cache[productId].timestamp < CACHE_EXPIRATION_TIME
    ) {
      return cache[productId].data;
    }

    const data = await getFromApi(productId);

    if (data) {
      cache[productId] = { data, timestamp: now };
    }

    return data;
  };

  const getExclusive = async (productId) => {
    const data = await get(productId);
    return data?.exclusive ?? null;
  };

  const getExcluded = async (productId) => {
    const data = await get(productId);
    return data?.excluded ?? [];
  };

  const getAvailableMarkets = async (productId) => {
    const data = await get(productId);
    return data?.markets ?? [];
  };

  return {
    clear,
    getExclusive,
    getExcluded,
    getAvailableMarkets
  };
})();

export default marketExclusiveService;
